import { defineStore } from "pinia";

import { Genders } from "@/types";

export type Gender = "male" | "female" | "nonbinary" | "unspecified";

interface State {
  username: string | null;
  gender: Gender | null;
  age: number | null;
  preferredCounselorGender: Genders | null;
}

export const useOnboardingStore = defineStore("onboarding", {
  state: (): State => ({
    username: null,
    gender: null,
    age: null,
    preferredCounselorGender: null,
  }),
  actions: {
    setUsername(username: string) {
      this.username = username;
    },

    setGender(gender: Gender) {
      this.gender = Genders[gender];
    },

    setAge(age: number) {
      this.age = age;
    },

    setPreferredCounselorGender(gender: Gender) {
      this.preferredCounselorGender = Genders[gender];
    },

    resetState() {
      this.username = null;
      this.gender = Genders.unspecified;
      this.age = null;
    },
  },
});
